module.exports = __webpack_public_path__ + "static/media/top-no-older-than-me-dark-icon.08deee79.svg";